"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseSchema = ListResponseSchema;
const zod_1 = require("zod");
function ListResponseSchema(schema, options) {
    return zod_1.z
        .object({
        object: zod_1.z.literal('list'),
        data: zod_1.z.array(schema).openapi(options.title),
    })
        .openapi(`${options.title}Response`);
}
//# sourceMappingURL=listSchema.js.map